'use strict';
module.exports = Groupon.setWindowLocation = function(href) {
  window.location.href = href;
  if (href.indexOf('#') > -1) {
    location.reload();
  }
};

